import { create } from 'zustand'
import { createAppsSlice } from './app/appsSlice'
import { createConfigSlice } from './app/configSlice'
import { createVersionsSlice } from './app/versionsSlice'
import type { AppState } from './app/types'

export type { AppState } from './app/types'
export { keepLocalPackageMeta } from './app/packageMeta'

/**
 * 应用域缓存，按 slice 组合：
 * - apps：应用基础信息（app/appsSlice）
 * - versions：版本列表、草稿与状态流转（app/versionsSlice）
 * - scopes / events / security / collaborators：应用配置（app/configSlice）
 */
export const useAppStore = create<AppState>()((...a) => ({
  ...createAppsSlice(...a),
  ...createVersionsSlice(...a),
  ...createConfigSlice(...a),
}))
